export default __webpack_public_path__ + "static/media/015-weightlifting.b17f9e65.svg";